import React, { useState, useEffect } from 'react';
import { defaultPage } from '../../Common/Constant';
import { masterData } from '../../api/master-data';
import * as blog from '../../api/blog';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar';
import Pagination from '../Layout/Pagination';
import { useNavigate } from "react-router-dom";
import { error } from 'jquery';

function BlogList() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Blog List - Clarion Audio";
    },);
    const [parentBlogID, setParentBlogID] = useState();
    const [parentBlog, setParentBlog] = useState();
    const [searchKeyword, setSearchKeyword] = useState();
    const [lists, setLists] = useState();
    const [pageInfo, setPageInfo] = useState({});
    const [errors, setErrors] = useState({});

    

    const getList = async() =>{        
        let res = await blog.getList({page: pageInfo.current_page, recPerPage: defaultPage.perPage, searchKeyword: searchKeyword, parentID: parentBlogID});
        if(res.status === 1){
            setLists(res.payload)
            setPageInfo(res.paginationInfo)
        } else{
            setLists([])
            //document.getElementById("noRecordMsg").innerHTML = "No blog found";
            setErrors({...errors,['records']:"No blog found"})

            
        }
    }

    useEffect(() => {
        getList();
    },[]);

    const updatePublish = async (id,publishedOn) => {
        let publish = (publishedOn !== null && publishedOn > 0) ? 0 : 1;
        let res = await blog.updatePublish({id:id,publish:publish});
        if(res && res.status === 1){
            getList();            
        }
    }

    const deleteRow = async (id) => {
        let res = await blog.trash({id:id})
        if(res && res.status === 1){
            getList()
        }
    }

    const changePage = (p) => {
        pageInfo.current_page = p;
        getList()
    }

    return (
        <div>
            <Sidebar />
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Blog List</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a >Home</a></li>
                                                <li className="breadcrumb-item">Blog</li>
                                                <li className="breadcrumb-item active">Blog List</li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="row mb-5 page-title-box d-sm-flex align-items-center justify-content-between">
                                <div className="col-xl-12 col-lg-12 d-flex justify-content-end mt-2 mb-2">
                                    <div className="col-2" style={{marginLeft: "10px", textAlign: "right"}}>
                                        <div className="form-group">
                                            <button className="btn btn-primary" onClick={() => navigate('/web/blog/add')}> <i className="ri-add-line"></i> Add Blog</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">
                                        {/* <!-- end card header --> */}
                                        <div className="card-body">
                                            {/* <div className='row'>
                                                <div className="col-md-9"></div>
                                                <div className="col-md-3">
                                                    <div className="mb-3">
                                                        <select className="form-select" data-choices data-choices-sorting="true" id="parentBlogID" onChange={(e) => setParentBlogID(e.target.value)}>
                                                            <option value={""} disabled selected key={0}>Select blog set</option>
                                                            {parentBlog?.map((row) => {
                                                                return (<option value={row.ID} key={row.ID} selected={row.ID === parentBlogID ? true : false}>{row.name}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <table className="table table-striped table-hover table_client">
                                                <thead>
                                                    <tr className="bg-primary" style={{color:"white"}}>
                                                        <th scope="col">Sr. No.</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Category</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Title</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Image</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Priority</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Created Date</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Publish Date</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Publish status</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                
                                                <tbody>
                                                {lists ? (<>
                                                    {lists?.length > 0 ? (<>
                                                        {lists?.map((row, i) => {
                                                            return(<>
                                                            <tr>
                                                                <td>{i+1}</td>
                                                                <td style={{textAlign:"left"}}>
                                                                    <span style={{textAlign:"left"}}>{row?.category}</span>
                                                                </td>
                                                                <td style={{textAlign:"left"}}>
                                                                    <span style={{textAlign:"left"}}>{row?.title}</span>
                                                                </td>
                                                                <td style={{textAlign:"left"}}>
                                                                    <img src ={(row?.leadImg!== null )? row?.leadImg: ""} style={{'height':'60px', width:'100%'}} alt=""/>
                                                                </td>
                                                                <td style={{textAlign:"left"}}>
                                                                    <span style={{textAlign:"left"}}>{row?.priority !== null ? row?.priority : "-"}</span>
                                                                </td>
                                                                <td style={{textAlign:"left"}}>
                                                                   <span style={{textAlign:"left"}}>{row?.createdDate}</span>
                                                                </td>
                                                                <td style={{textAlign:"left"}}>
                                                                    <span style={{textAlign:"left"}}>{(row?.publishedDate != null)?row?.publishedDate:"-"}</span>
                                                                </td>
                                                                <td style={{textAlign:"left"}}>
                                                                    <div className="form-check form-switch">
                                                                        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={(row.publishedOn !== null && row.publishedOn !== 0)? "checked" : ""} onChange={()=>updatePublish(row.ID, row.publishedOn)} />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span className="p-2 font-16" title="Edit blog"> 
                                                                        <i className="ri-edit-2-line pointerC" onClick={() => navigate('add?id=' + row.ID, { state: row.ID })}></i>
                                                                    </span>
                                                                    <span className="p-2 font-16" title="Delete blog">
                                                                        <i className="ri-delete-bin-2-line del pointerC" onClick={() => deleteRow(row?.ID)}></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            </>)
                                                        })}
                                                    </>) : (<>
                                                        <tr>
                                                            <td colSpan={5} id="noRecordMsg">{(error?.records)?error?.records:"Loading Blogs..."}</td>
                                                        </tr>
                                                    </>)}
                                                </>) : (<>
                                                </>)}
                                                    
                                                </tbody>
                                            </table>
                                            <Pagination pageInfo={pageInfo} changePage={changePage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default BlogList